import React from 'react';
import {
  DialogTitle,
  DialogContentText,
  DialogContent,
  Button,
  DialogActions,
  Typography,
  TableContainer,
  TableCell,
  TableBody,
  TableHead,
  TableRow,
  Paper,
  Table,
  Card
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import {hazardRisks} from '../../constants';

import Dialog from '../Dialog';
//import { tableCellClasses } from '@material-ui/tableCellClasses';

const useStyles = makeStyles((theme) => {
  return {
    customTable: {

      '& .MuiTableCell-root' : {
      'border-right' :   '1px solid rgba(224, 224, 224, 1)'
      }
 
     
     
      
    },
    errorMessage: {
      color: 'red',
      position: 'absolute',
      left: 20
    },
    actionButton: {
      width: 180,
      float: 'right',
      margin: theme.spacing(2)
    },
    customCell:{
      cursor: "pointer",
      "&: hover" : {backgroundColor: "#000000"}
   }
  };
});


const CustomCell = (props) => {
  const {
    item,
    handleCellClicked
  } = props;
  const classes = useStyles();

  const [color, setColor] = React.useState(item.color);

  const changeColor = () => {
    setColor("#cccccc");
  }

 const resetColor = () => {
  setColor(item.color);
  }

  return (
  
        <TableCell
                align="center"
                key={item.id} 
                component="td" scope="row"
                onClick={() => handleCellClicked(item)}
                className={classes.customCell}
                onMouseEnter = {changeColor}
                onMouseLeave= {resetColor}
                width = {170}
                style = {{backgroundColor: color}}
                >  
                    <b>{item.hasIndexNumber ? item.indexNumber : ""}</b> {item.hasIndexNumber  && <br/>} <b>{item.heading} </b><br/>  {item.subHeading}
         </TableCell>

  );
};


const HazardConsequncesDialog = (props) => {
  const classes = useStyles();

  const {
    open,
    handleSubmit,
    handleClose
  } = props;


  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth ={false}
      >
        <DialogTitle id="alert-dialog-title"  align="center">Consequnces (Impact) </DialogTitle>

        <DialogTitle id="alert-dialog-title"  align="center">How severely some one could be injured</DialogTitle>
        
        
      
        <DialogContent>
        <TableContainer component={Paper}>
      <Table size="small" aria-label="a dense table"  className={classes.customTable}  sx={{ minWidth: 580 }}>
        <TableHead>
          <TableRow>
            <TableCell align="center"><b>Likelihood</b></TableCell>
            <TableCell align="center"> <b>1</b><br/><b>Insignificant</b><br/>(No injuries)</TableCell>
            <TableCell align="center"><b>2</b><br/><b>Minor</b><br/>(First Aid treatment on site)</TableCell>
            <TableCell align="center"><b>3</b><br/><b>Moderate</b><br/>(Medical treatment)</TableCell>
            <TableCell align="center"><b>4</b><br/><b>Major</b><br/>(Extensive injuries)</TableCell>
            <TableCell align="center"><b>5</b><br/><b>Catastrophic</b><br/>(Fatality)</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {hazardRisks.map((row) => (
            <TableRow
              key={row.index}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              {
                row.columns.map((dataColumn) => 

                dataColumn.hasIndexNumber === true ? 
                <TableCell
                align="center"
                key={dataColumn.id} 
                component="th" scope="row"
                >
                        <b>{dataColumn.hasIndexNumber ? dataColumn.indexNumber : ""}</b> {dataColumn.hasIndexNumber  && <br/>} <b>{dataColumn.heading} </b><br/>  {dataColumn.subHeading}
              </TableCell> :

                <CustomCell item = {dataColumn}  handleCellClicked = {handleSubmit} > </CustomCell>

                )
              }
             
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>

        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            color="primary"
            onClick={handleClose}
            id="cancelButton"
            className={classes.actionButton}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};


export default HazardConsequncesDialog;
